import {ajaxGet,ajaxPost,ajaxDelete,ajaxPut,formData,formDataPut,ajaxGetNoJWT,ajaxPostNoJWT} from '../request'

//栏目模块
export const columnGet = params => ajaxGet({url:"article/column/",params})
export const columnPost = params => formData({url:"article/column/",params})
export const columnPut = params => formDataPut({url:"article/column/"+params.id+"/",params})
export const columnDelete = params => ajaxDelete({url:"article/column/"+params+"/"})

//文章模块
export const articleGet = params => ajaxGet({url:"article/article/",params})
export const articleGetDetail = params => ajaxGetNoJWT({url:"article/article/"+params})
export const articlePost = params => ajaxPost({url:"article/article/",params})
export const articlePut = params => ajaxPut({url:"article/article/",params})
export const articleDelete = params => ajaxDelete({url:"article/article/"+params+"/"})

//分类模块
export const categoryGet = params => ajaxGet({url:"article/category/",params})
export const categoryPost = params => ajaxPost({url:"article/category/",params})
export const categoryPut = params => ajaxPut({url:"article/category/",params})
export const categoryDelete = params => ajaxDelete({url:"article/category/"+params+"/"})
export const categoryDeleteMultiple = params => ajaxDelete({url:"article/category/multiple_delete/",params})

//文件模块
export const fileGet = params => ajaxGet({url:"article/file/",params})
export const filePost = params => formData({url:"article/file/",params})
export const fileDelete = params => ajaxDelete({url:"article/file/"+params+"/"})

//评论模块
export const commentGet = params => ajaxGetNoJWT({url:'article/comment/',params})
export const commentPost = params => ajaxPost({url:'article/comment/',params})
export const commentDelete = params => ajaxDelete({url:'article/comment/',params})

//常用下载
export const downloadGet = params => ajaxGetNoJWT({url:"article/download/",params})
export const downloadPost = params => formData({url:"article/download/",params})
export const downloadDelete = params => ajaxDelete({url:"article/download/"+params})

//无jwt
export const register = params => ajaxPostNoJWT({url:"users/register/",params})
export const columnGet2 = params => ajaxGetNoJWT({url:"article/column/",params})
export const articleGet2 = params => ajaxGetNoJWT({url:"article/article/",params})


//院长信箱
export const messageGet = params => ajaxGet({url:"article/message/",params})
export const messagePost = params => formData({url:"article/message/",params})
export const messageDelete = params => ajaxDelete({url:"article/message/"+params})
export const messageGetDetail = params => ajaxGet({url:"article/message/"+params.id+"/"})

//在线投稿
export const articlePost2 = params => ajaxPost({url:"article/article/",params})

//获取部门
export const apiSystemDept = params => ajaxGet({url: `system/dept/`,params})

//底部法院联动
export const courtGet = params => ajaxGetNoJWT({url:"article/link/",params})//一级三级
export const cityGet = params => ajaxGetNoJWT({url:"article/linktype/",params})//二级